import produce from 'immer';

import {StepItemStatus} from 'ui-library/StepNav';

import {DatasetColumnTypeMetadata, DatasetConfigModalState, StepKey} from './DatasetConfigConstants';

export enum DatasetConfigModalActionType {
  UPDATE_ANALYSIS_TEMPLATE = 'UPDATE_ANALYSIS_TEMPLATE',
  UPDATE_COLUMN_TYPE_METADATAS = 'UPDATE_COLUMN_TYPE_METADATAS',
  UPDATE_CURRENT_STEP = 'UPDATE_CURRENT_STEP',
}

interface UpdateAnalysisTemplateAction {
  type: DatasetConfigModalActionType.UPDATE_ANALYSIS_TEMPLATE;
  analysisTemplate: string | null;
}

interface UpdateColumnTypeMetadatasAction {
  type: DatasetConfigModalActionType.UPDATE_COLUMN_TYPE_METADATAS;
  columnTypeMetadatas: Array<DatasetColumnTypeMetadata>;
}

interface UpdateCurrentStepAction {
  type: DatasetConfigModalActionType.UPDATE_CURRENT_STEP;
  nextStepKey: StepKey;
  columnTypeMetadatas?: Array<DatasetColumnTypeMetadata>;
}

export type DatasetConfigModalAction =
  | UpdateAnalysisTemplateAction
  | UpdateColumnTypeMetadatasAction
  | UpdateCurrentStepAction;

export default function datasetConfigModalReducer(
  state: DatasetConfigModalState,
  action: DatasetConfigModalAction
): DatasetConfigModalState {
  switch (action.type) {
    case DatasetConfigModalActionType.UPDATE_ANALYSIS_TEMPLATE: {
      return produce(state, (draftState) => {
        if (action.analysisTemplate !== state.analysisTemplate) {
          draftState.analysisTemplate = action.analysisTemplate;
          // reset template column mappings when analysis template is changed
          draftState.columnTypeMetadatas = state.columnTypeMetadatas.map(
            ({templateColumnName, ...remainingKeys}) => remainingKeys
          );
        }
      });
    }
    case DatasetConfigModalActionType.UPDATE_COLUMN_TYPE_METADATAS: {
      return produce(state, (draftState) => {
        draftState.columnTypeMetadatas = action.columnTypeMetadatas;
      });
    }
    case DatasetConfigModalActionType.UPDATE_CURRENT_STEP: {
      return produce(state, (draftState) => {
        if (action.nextStepKey === StepKey.COLUMNS) {
          draftState.statusByStep[StepKey.COLUMNS] = StepItemStatus.UNVISITED;
        } else if (action.nextStepKey === StepKey.ANALYSIS_TEMPLATE) {
          draftState.statusByStep[StepKey.COLUMNS] = StepItemStatus.DONE;
          draftState.statusByStep[StepKey.ANALYSIS_TEMPLATE] = StepItemStatus.UNVISITED;
        }
        draftState.currentStepKey = action.nextStepKey;
      });
    }
    default:
      return state;
  }
}
